import React from 'react';

import { useHeight } from '../../hooks';
import { getEmbedSrc } from '../helpers';
import { VideoProps } from '../types';

export const IframePlayer = ({ src }: VideoProps) => {
  const { maxHeight } = useHeight();

  return (
    <iframe
      src={getEmbedSrc(src)}
      width="100%"
      height={maxHeight}
      allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title="Embedded Video"
    />
  );
};
